"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetPosition = exports.GetChangeSnackbarDisplay = void 0;
const theme_1 = require("@icr-ui/theme");
const styled_components_1 = require("styled-components");
const styles_1 = require("./styles");
const GetChangeSnackbarDisplay = ({ block }) => {
    if (block) {
        return (0, styled_components_1.css) `
      ${styles_1.StyledSnackbarButtonBox} {
        padding-top: ${theme_1.spacings.s3};
        margin: 0;
      }
      ${styles_1.StyledSnackbarCloseIcon} {
        right: 20px;
        top: 22.8%;
        margin-left: auto;
      }
      ${styles_1.StyledSnackbarText} {
        margin-right: 20px;
      }
      flex-direction: column;
      align-items: flex-start;
    `;
    }
    else {
        return (0, styled_components_1.css) `
      ${styles_1.StyledSnackbarCloseIcon} {
        top: 50%;
        right: 20px;
        transform: translateY(-50%);
      }
      ${styles_1.StyledSnackbarTextBox} {
        margin-right: 22.5px;
      }
    `;
    }
};
exports.GetChangeSnackbarDisplay = GetChangeSnackbarDisplay;
const SetPosition = (position) => {
    switch (position) {
        case 'bottom-left':
            return (0, styled_components_1.css) `
        bottom: 5%;
        left: 5%;
      `;
        case 'bottom-center':
            return (0, styled_components_1.css) `
        bottom: 0;
        left: 50%;
        transform: translate(-50%, -50%);
      `;
        case 'bottom-right':
            return (0, styled_components_1.css) `
        bottom: 5%;
        right: 5%;
      `;
        case 'top-left':
            return (0, styled_components_1.css) `
        top: 5%;
        left: 5%;
      `;
        case 'top-center':
            return (0, styled_components_1.css) `
        top: 10%;
        left: 50%;
        transform: translate(-50%, -50%);
      `;
        case 'top-right':
            return (0, styled_components_1.css) `
        top: 5%;
        right: 5%;
      `;
        default:
            return (0, styled_components_1.css) `
        bottom: 5%;
        right: 5%;
      `;
    }
};
exports.SetPosition = SetPosition;
//# sourceMappingURL=utils.js.map